import BaseListPresenter from "../../../base/BaseListPresenter";

class ClientsListPagePresenter extends BaseListPresenter {
  constructor(
    view,
    findObjectUseCase,
    countObjectUseCase,
    deleteObjectUseCase,
    upsertUseCase,
    getCurrentUserUseCase,
    getObjectUseCase,
  ) {
    super(
      view,
      findObjectUseCase,
      countObjectUseCase,
      deleteObjectUseCase,
      upsertUseCase,
      getCurrentUserUseCase,
      getObjectUseCase,
    );
    this.upsertUseCase = upsertUseCase;
    this.getCurrentUserUseCase = getCurrentUserUseCase;
    this.getObjectUseCase = getObjectUseCase;

    this.objects = [];
  }

  async componentDidMount() {
    const clientId = this.view.getClientId();
    if (clientId) {
      await this.getUserClient();
    }
    this.init();
    this.findObjects();
    this.countObjects();
  }

  init() {
    const user = this.view.getCurrentUser();
    const isAdmin = this.view.isAdmin();
    const { userObject } = this.view.state;

    this.limit = 20;
    this.where = {
      //Admin/Accountant role's direct client
      ...(isAdmin &&
        !userObject?.client?.id && {
          $and: [{ creator: { id: user?.id } }, { clientOf: "admin" }],
        }),

      //Admin/Accountant role's indirect client
      ...(isAdmin &&
        userObject?.client?.id && { user: { id: userObject?.id } }),

      //Non-Admin role's direct client
      ...(!isAdmin &&
        !userObject?.client?.id && {
          $and: [{ user: { id: user?.id } }, { clientOf: "client" }],
        }),
    };

    this.search = {};
    this.filter = {};
    this.include = ["all"];
    this.keys = undefined;
    this.sort = { created: -1 };
    this.progress = true;
    this.reset();
  }

  async findObjects() {
    const collection = this.view.getCollectionName();
    const query = this.createQuery();

    try {
      this.view.showProgress();
      this.findObjectUseCase.abort();
      const objects = await this.findObjectUseCase.execute(collection, query);
      this.objects = this.objects.concat(objects);
      this.view.setTotal(this.objects.length);
      this.view.setObjects(this.objects);
      this.hideProgress();
    } catch (error) {
      this.hideProgress();
      this.view.showError(error);
    }
    this.progress = false;
  }

  async onSubmit(object) {
    const collection = this.view.getCollectionName();
    try {
      await this.upsertUseCase.execute(collection, object);
      this.getObjects();
    } catch (error) {
      this.view.showError(error);
    }
  }

  async onSubmitModal(collection, object) {
    const updatedObject = { ...object };
    try {
      this.view.showProgress();

      await this.upsertUseCase.execute(collection, updatedObject);

      this.view.hideProgress();
      this.view.showSuccess("Data Added Successfully!");
    } catch (error) {
      this.view.showError(error);
    }
  }

  async updateBooleanFieldBulk(objects, field, value) {
    if (!this.upsertUseCase || !objects?.length) return;
    const collection = this.view.getCollectionName();
    try {
      for (const object of objects) {
        const id = object?.id ?? object?.objectId;
        if (!id) continue;
        await this.upsertUseCase.execute(collection, { id, [field]: value });
        if (typeof this.view.updateObjectInList === "function") {
          this.view.updateObjectInList(id, { ...object, [field]: value });
        }
      }
      if (typeof this.view.setSelected === "function") {
        this.view.setSelected([]);
      }
      if (typeof this.view.showSuccessToast === "function") {
        this.view.showSuccessToast(
          objects.length === 1
            ? "Updated successfully"
            : `${objects.length} items updated successfully`,
        );
      }
    } catch (error) {
      this.view.showError(error);
    }
  }

  getMonths() {
    const year = new Date().getFullYear();
    const months = Array.from({ length: 12 }, (_, i) => {
      return new Intl.DateTimeFormat("en-US", { month: "long" }).format(
        new Date(year, i, 1),
      );
    });

    return months;
  }

  async getUserClient() {
    const collection = "users";
    const clientId = this.view.getClientId();
    const query = {
      where: {
        client: {
          id: clientId,
        },
      },
      include: ["client"],
    };

    try {
      this.showProgress();

      const user = await this.findObjectUseCase.execute(collection, query);
      await new Promise((resolve) => {
        this.view.setState(
          { userObject: user[0] ? { ...user[0] } : {} },
          resolve,
        );
      });
      this.hideProgress();
    } catch (error) {
      this.hideProgress();
      this.view.showError(error);
    }
  }
}

export default ClientsListPagePresenter;
